/** Sabit Google Maps yol tarifi linki — CMS/Supabase üzerinden değiştirilemez. */
export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps?q=Car+Garage,+Ye%C5%9Filba%C4%9Flar+mh.+Azim+sk.+No:11,+Yanyol+%C3%BCzeri,+34893+Pendik/%C4%B0stanbul&ftid=0x14cac53bec9c5c4f:0x15c0be365641efeb&entry=gps";

export const MAPS_HREF_SENTINEL = "MAPS_URL";

export function isMapsHref(href: string): boolean {
  return href === MAPS_HREF_SENTINEL || href.includes("google.com/maps");
}

export function resolveMapsHref(href: string): string {
  return isMapsHref(href) ? MAPS_DIRECTIONS_URL : href;
}
